import React, { useEffect } from 'react';
import { useField } from 'formik';
// import { useTranslation } from 'react-i18next';

import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import { numToLetter } from '~/commons/helpers';

const FieldsSingleSelect = ({
  idx,
  qtnIndex: i,
  restrictEdit = false,
}) => {
  const [, { value }] = useField(`questionSets[${idx}].questions.${i}`);
  const [,, { setValue: setAns }] = useField(`questions.${i}.answer`);
  // const { t } = useTranslation();
  const { answer } = value;
  let { choices } = value;

  if (!restrictEdit && !choices.slice(-1)[0]) {
    choices = choices.slice(0, -1);
  }

  useEffect(() => {
    if (answer >= choices.length) {
      setAns(null);
    }
  }, [choices.length]);

  return (
    <>
      <label>答案 *</label>
      <FieldArrayIterables
        name={`questionSets[${idx}].questions.${i}.choices`}
        {...restrictEdit ? {} : {
          tail: '',
        }}
      >
        {(c, ii) => (
          <div
            className="form-row align-items-center"
            key={ii}
          >
            <div className="col-auto pb-3">
              {numToLetter(ii, true)}.
            </div>
            <div className="col">
              <FormGroup
                radio={{
                  name: `questionSets[${idx}].questions.${i}.answer`,
                  value: ii.toString(),
                  disabled: ii >= choices.length,
                }}
                name={`questionSets[${idx}].questions.${i}.choices.${ii}`}
                label={null}
              />
            </div>
          </div>
        )}
      </FieldArrayIterables>
    </>
  );
};

export default FieldsSingleSelect;
